<template>
  <div>
    <div id="app" class="payment-info">
      <h4>
        <font-awesome-icon icon="lock" />{{ strings.securePaymentInformation }}
      </h4>
      <iframe
        ref="paymentIframe"
        @load="iframeLoad"
        scrolling="no"
        style="width: 100%; border:none;overflow: hidden; margin-left:-2%"
        height="403"
        :src="pciURL"
      ></iframe>
      <div v-if="bookingError" class="paymentError">
        {{ bookingError }}
      </div>
    </div>
  </div>
</template>
<script>
import VModal from "vue-js-modal";
import { Card, createToken } from "vue-stripe-elements-plus";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Vue from "vue";
library.add(faLock);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

export default {
  name: "PCICaptureToken",
  data() {
    return {
      pciURL: "",
      pciHost: "",
      baseURLWithLang: "",
      orderSuccessURL: "",
      fullRefundText: "",
      value: 0,
      bookingError: false,
      newAccessToken: 111,
      checkboxAgree: false,
      validationErrorString: ""
    };
  },
  mounted() {
    let accessToken = window.pciAccessToken + ',' +  window.pciAccessToken2;
    console.log(this.totalCartPrice);
    this.preparePCI(accessToken,  {"currency": this.currency, "amount_cents": this.totalCartPrice });
    if (window.addEventListener) {
      window.addEventListener("message", this.handleFrameMessage);
    } else if (window.attachEvent) {
      window.attachEvent("onmessage", this.handleFrameMessage);
    }
  },
  created: function() {
    this.$parent.$on("reloadIframe", this.checkForm);
    this.$parent.$on("refreshUrl", this.refreshUrl);
    this.$root.$on("reloadIframe2", this.reloadIframe);
  },

  computed: {
    strings() {
      return this.$store.state.strings;
    },
    isDavinci() { 
      return state => state.cart.venue_info.is_davinci
    },
    currency() { 
      return  state.cart?.events[0]?.price?.currency
    },
    totalCartPrice() { 
      let total_price = this.$store.state.cart?.events[0]?.price?.total_price;
      let min_spend = this.$store.state.cart?.events[0]?.price?.minimum_spend;
      if(min_spend && min_spend > 0){
        total_price = total_price + min_spend;
      }
      return total_price;
    }

  },
  methods: {
    showEstimatedLocalPrice() {
      if (this.$store.state.cart?.localization?.currency !== this.$store.state.cart?.events[0]?.price?.currency) {
        return true
      }
      return false
    },
    preparePCI: function(accessToken, params) {
      let site_url = window.location.protocol + '//' + window.location.hostname + window.mp_url_settings["BASE_URL"];
      let lang = "en";
      let brandName = "MeetingPackage";
      let successURL = site_url + "/apiv2/getcardtoken/success?cardToken={cardToken}";
      let failureURL = site_url + "/apiv2/getcardtoken/failure";
      this.pciHost = window.pciHostUrl
        ? window.pciHostUrl
        : "https://cf-service.pcibooking.net";
      successURL = encodeURIComponent(successURL);
      failureURL = encodeURIComponent(failureURL);
      this.pciURL = this.pciHost + "/api/payments/capturecard";
      this.pciURL += "?brand=" + brandName;
      this.pciURL += '&accessToken=' + accessToken;
      this.pciURL += "&cvv=true";
      this.pciURL += "&success=" + successURL;
      this.pciURL += "&failure=" + failureURL;
      this.pciURL += "&submitWithPostMessage=true";
      this.pciURL += "&language=" + lang;
      this.pciURL += "&autoDetectCardType=" + "true";
      this.pciURL += "&autoFocus=" + "false";
      this.pciURL += '&ThreeDS=' + 'true';
      this.pciURL += "&css=" + "PCI_Style";
      if(window.pciMerchantName){
         this.pciURL += "&merchantName=" + window.pciMerchantName;
      }
      if(params && params.amount_cents){
         this.pciURL += "&amount=" + params.amount_cents;
         this.pciURL += "&currencyCode=" + params.currency;
      }
    },
    refreshUrl(params) {
      let accessToken = window.pciAccessToken  + "," +window.pciAccessToken2 ;
      this.preparePCI(accessToken, params);
      this.$refs.paymentIframe.contentWindow.location.reload();
    },
    checkForm: function() {
      var host = this.pciHost + "/";
      let self = this;
      var receiver = self.$refs.paymentIframe.contentWindow;
      let d = receiver.postMessage("validate", host);
    },
    iframeLoad() {
      let self = this;
      let callBackURL = self.$refs.paymentIframe.contentWindow.location.href;
      callBackURL = decodeURIComponent(callBackURL);
      let indexToken = callBackURL.indexOf("paycard");
      let cardToken = callBackURL.substr(indexToken + 8);
      cardToken = encodeURIComponent(cardToken);
      console.log(cardToken);
      if (cardToken.length > 5) {
        console.log("here");
        this.$emit("successCB", cardToken);
      }
    },
    reloadIframe(accessToken) {
      this.preparePCI(accessToken)
      this.$refs.paymentIframe.contentWindow.location.reload();
    },
    handleFrameMessage(e) {
      let self = this;
      var receiver = self.$refs.paymentIframe.contentWindow;
      var host = this.pciHost;
      var originDomain = e.origin
        .replace("http://", "")
        .replace("https://", "");
      var postMessageOrigin = host
        .replace("http://", "")
        .replace("https://", "")
        .toLowerCase();
      if (postMessageOrigin.endsWith("/"))
        postMessageOrigin = postMessageOrigin.substring(
          0,
          postMessageOrigin.length - 1
        );

      if (originDomain.toLowerCase() === postMessageOrigin) {
        if (e.data == "ready") {
          iframeIsReady = true;
        } else if (e.data == "valid") {
          receiver.postMessage("submit", host);
        } else if (e.data.indexOf("frameDimensionsChanged") === 0) {
          var objectParts = e.data.split(":");
          var width = parseInt(objectParts[1]);
          var height = parseInt(objectParts[2]);
        } else if (e.data[0] === "{") {
        } else {
        }
      }
    }
  }
};
</script>

<style scoped>
.payment-info h4 {
  margin-bottom: 0px;
  margin-top: 1em;
  margin-left: 0;
}
.cancellation-alert {
  margin-top: 30px;
}

.cancellation-alert ul {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
}
</style>
